import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { device } from '../breakpoints'

interface VideoCoverProps {
  videoSrc: string
}

const VideoCover: FC<VideoCoverProps> = ({ videoSrc }): ReactElement => {
  return (
    <Container>
      <VideoContainer>
        <Video autoPlay loop playsInline muted>
          <source src={videoSrc} type='video/mp4' />
          Your browser does not support the video tag.
        </Video>
      </VideoContainer>
      <VideoContainer>
        <Video autoPlay loop playsInline muted>
          <source src={videoSrc} type='video/mp4' />
          Your browser does not support the video tag.
        </Video>
      </VideoContainer>
      <VideoContainer>
        <Video autoPlay loop playsInline muted>
          <source src={videoSrc} type='video/mp4' />
          Your browser does not support the video tag.
        </Video>
      </VideoContainer>
    </Container>
  )
}

const Container = styled.div`
  background-color: #54b2bd;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1em;
  }
`

const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

const VideoContainer = styled.div`
  position: relative;
  display: none;
  width: 100%;
  overflow: hidden;

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  &:first-child {
    display: block;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
  }

  @media ${device.tablet}, @media ${device.laptop} {
    display: block;
    width: 33.33333%;

    &:first-child {
      ${Video} {
        left: 0;
        top: -50%;
        width: 200%;
        filter: blur(40px);
      }
    }

    &:last-child {
      ${Video} {
        top: -50%;
        width: 200%;
        left: -100%;
        filter: blur(40px);
      }
    }
  }
`

export default VideoCover
